import Vue from 'vue'
import Router from 'vue-router'

// Import pages
import Home from '@/pages/Home'
import How from '@/pages/howitworks'
import Company from '@/pages/Company'
import TermsOfUse from '@/pages/termsOfUse'
import PrivacyPolicy from '@/pages/privacyPolicy'
import CookiePolicy from '@/pages/cookiePolicy'
import PageNotFound from '@/pages/404.vue'
import PrimeInc from '@/pages/primecase.vue'

import Scrollactive from 'vue-scrollactive'
const VueScrollTo = require('vue-scrollto')

Vue.use(Scrollactive)
Vue.use(VueScrollTo, { offset: -80 })
Vue.use(Router)

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    console.log('to: ', to)
    console.log('from: ', from)
    return savedPosition
  } else {
    const position = {}

    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash
      // offset
      position.offset = { y: 80 }
      // specify offset of the element
      // if (to.hash === '#anchor2') {
      //   position.offset = { y: 100 }
      // }

      if (document.querySelector(to.hash)) {
        // console.log('pos: ', position)
        return position
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return false
    }

    if (!to.hash) {
      // console.log('not: ', to)
      VueScrollTo.scrollTo('body', 400)
    }

    // return new Promise(resolve => {
    //   // check if any matched route config has meta that requires scrolling to top
    //   if (to.matched.some(m => m.meta.scrollToTop)) {
    //     // coords will be used if no selector is provided,
    //     // or if the selector didn't match any element.
    //     position.x = 0
    //     position.y = 0
    //   }

    //   // wait for the out transition to complete (if necessary)
    //   this.app.$root.$once('triggerScroll', () => {
    //     // if the resolved position is falsy or an empty object,
    //     // will retain current scroll position.
    //     resolve(position)
    //   })
    // })
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Homepage'
      }
    },
    {
      path: '/how-it-works',
      name: 'how',
      component: How,
      meta: {
        title: 'How it works'
      }
    },
    {
      path: 'https://assessment.twegos.com/en-en/privacypolicy',
      name: 'TermsOfUse',
      component: TermsOfUse,
      meta: {
        title: 'Terms of use'
      }
    },
    {
      path: 'https://assessment.twegos.com/en-en/privacy-statement',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: {
        title: 'Privacy policy'
      }
    },
    {
      path: '/cookiePolicy',
      name: 'CookiePolicy',
      component: CookiePolicy,
      meta: {
        title: 'Cookie policy'
      }
    },
    {
      path: '/company',
      name: 'Company',
      component: Company,
      meta: {
        title: 'Company'
      }
    },
    {
      path: '/case/prime',
      name: 'Prime Case',
      component: PrimeInc,
      meta: {
        title: 'Prime Case'
      }
    },

    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound,
      meta: {
        title: 'Error 404'
      }
    }
  ],
  scrollBehavior
})



// WEBPACK FOOTER //
// ./src/router/index.js